import fetchMerchandiseBrandsList from 'actions/merchandise/fetchMerchandiseBrandsList'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect } from 'react'

type ReturnType = [
  Array<string>,
  boolean,
  any | undefined,
]

interface Options {
  disabled?: boolean
}

function useMerchandiseBrandsList(filters: App.MerchandiseBrandFilters | undefined, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()

  const key = getObjectKey(filters ?? {})
  const brandList = useAppSelector(state => state.merchandise.merchandiseBrandLists[key])
  const fetching = useAppSelector(state => state.merchandise.fetchingMerchandiseBrandLists[key])
  const error = useAppSelector(state => state.merchandise.merchandiseBrandListErrors[key])

  useEffect(() => {
    if (!options.disabled && filters) {
      dispatch(fetchMerchandiseBrandsList(filters))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, key, options.disabled])

  return [
    brandList ?? EmptyArray,
    (!!fetching || !brandList) && !options.disabled,
    error,
  ]
}

export default useMerchandiseBrandsList
